module.exports = __webpack_public_path__ + "static/media/apartment17.43934bbe.jpg";